import React, { useEffect, useState } from 'react';
import './Hero.css';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1663160665977-b06ef934ad8d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdW5yaXNlJTIwY2l0eSUyMHNreWxpbmUlMjBvcHBvcnR1bml0eXxlbnwxfHx8fDE3NjQxNzk3NjZ8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral';

export function Hero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero">
     <div 
        className="hero-background"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`
        }}
      >
        <video
          className="hero-video"
          src={`${process.env.PUBLIC_URL}/videoplayback.mp4`}   // <-- your video file
          autoPlay
          loop
          muted
          playsInline
        />

        <div className="hero-overlay"></div>
      </div>

      
      <div className="hero-content">
        <h1 className="hero-title fade-in">
          Your Journey. Your Growth. One Platform.
        </h1>
        <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
          Comprehensive programs empowering professionals to grow, evolve, and master their craft.
        </p>
        <div className="hero-actions fade-in" style={{ animationDelay: '0.4s' }}>
          <button className="btn btn-primary">Start Your Journey</button>
          <button className="btn btn-secondary">Explore Programs</button>
        </div>
      </div>
    </section>
  );
}